
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { B2CAuthConfig } from "./abstraction/b2cAuthConfig";
import { EnvironmentConfig } from "./abstraction/environmentConfig";

const authentication: B2CAuthConfig = {
  authFlow: "#{UserManagement.Flow}#",
  authClientId: "#{DiflexmoAuth.ApplicationRegistration.UIClientId}#",
  userManagementScope: "#{UserManagement.Scope}#",
  userManagementApiUrl: "#{UserManagement.Url}#",
  tenant: "#{DiflexmoAuth.Tenant}#",
  fordeskApiScope: "#{DiflexmoAuth.FordeskScope}#",
  postLogoutRedirectUri: `${window.location.origin}`,
  redirectUrl: `${window.location.origin}`,
  b2cDiflexmoTenantId: '#{DiflexmoAuth.ApplicationRegistration.B2CTenantId}#',
  b2cAppregistrationInstance: '#{DiflexmoAuth.ApplicationRegistration.Instance}#'
}

export const environment: EnvironmentConfig = {
  syncfusionAspNetCoreLicenseKey: "#{SyncfusionAspNetCoreLicenseKey}#",
  production: false,
  authentication: authentication,
  name: "DEV",
  integrationSettings: {
    isCustomsEnabled: true,
    isCreateOutgoingInvoiceEnabled: true,
  },
  notificationsRefreshRate: 60000,
  applicationUrl: "https://development.fordesk.net",
  clientApiConfig: {
    host: "https://development.fordesk.net",
    baseUrl: "api"
  },
  identityApiConfig: {
    host: "https://security-development.fordesk.net",
    baseUrl: "api"
  },
  forDeskApiConfig: {
    host: "https://api-development.fordesk.net",
    baseUrl: "api"
  }
};
